import { RootState } from "../root-reducer";

export const selectCurrentOrganization = (state: RootState) =>
  state.organizations.currentOrganization;

export const selectOrganizationName = (state: RootState) =>
  state.organizations.currentOrganization?.name;

export const selectOrganizationLoading = (state: RootState) =>
  state.organizations.loading;

export const selectOrganizationError = (state: RootState) =>
  state.organizations.error;
